import { render, staticRenderFns } from "./StackTrace.vue?vue&type=template&id=539286b4&"
import script from "./StackTrace.vue?vue&type=script&lang=ts&"
export * from "./StackTrace.vue?vue&type=script&lang=ts&"
import style0 from "./StackTrace.vue?vue&type=style&index=0&id=539286b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports